import React from "react";
import { Layout, Row, Col, Menu, Image, Typography, Divider } from "antd";
import {
  LinkedinOutlined,
  FacebookOutlined,
  InstagramOutlined,
  YoutubeOutlined,
} from "@ant-design/icons";
import { Avatar } from "antd";
import { Icon } from "@iconify/react";
import logo from "@assets/SVG/logo.svg";
import FooterImage from "@assets/KPMG/Footer.png";
import styles from "./Footer.module.scss";
import { Fade } from "react-awesome-reveal";
import { useNavigate } from "react-router-dom";

const { Footer } = Layout;

interface SocialMediaLink {
  url: string;
  icon: string;
}

const socialMediaLinks: SocialMediaLink[] = [
  { url: "https://www.linkedin.com/", icon: "ri:linkedin-fill" },
  { url: "https://www.facebook.com/", icon: "uim:facebook-f" },
  { url: "https://www.instagram.com/", icon: "mdi:instagram" },
  { url: "https://www.youtube.com/", icon: "mdi:youtube" },
];
const links = [
  { label: "Legal", url: "#" },
  { label: "Privacy", url: "#" },
  { label: "Accessibility", url: "#" },
  { label: "Sitemap", url: "#" },
  { label: "Help", url: "#" },
  { label: "Glossary", url: "#" },
  { label: "Events", url: "#" },
  { label: " Cookie Preferences", url: "#" },
];

export const AppFooter = () => {
  const navigate = useNavigate();
  return (
    <div style={{}}>
      <Fade direction="down" triggerOnce>
        <Row>
          <Col span={5}></Col>
          <Col span={14}>
            <div
              onClick={() => {
                // navigate("/knowledge-hub")
              }}
            >
              <img
                src={FooterImage}
                style={{
                  maxWidth: "100%",
                  width: "100%",
                  // cursor: "pointer",
                  maxHeight: 240,
                }}
              />
            </div>
          </Col>
          <Col span={5}></Col>
        </Row>
        <Footer>
          <Row>
            <Col lg={2}></Col>
            <Col lg={20}>
              <div style={{ display: "flex" }}>
                <div style={{ width: 240 }}>
                  <Image
                    src={logo}
                    preview={false}
                    style={{
                      maxWidth: 140,
                    }}
                  />
                </div>
                <div style={{ width: "100%" }}>
                  <Typography.Text className="textSmall">
                    KPMG firms operate in 143 countries and territories, and in
                    FY22, collectively employed more than 265,000 partners and
                    people, serving the needs of business, governments,
                    public-sector agencies, not-for-profits and through KPMG
                    firms' audit and assurance practices, the capital markets.
                  </Typography.Text>
                </div>
              </div>
              <Divider />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex" }}>
                  {links.map((link, index: number) => (
                    <a
                      key={index}
                      href={link.url}
                      style={{ marginRight: 40, color: "#003087" }}
                      className="textSmall"
                    >
                      {link.label}
                    </a>
                  ))}
                </div>
                <div style={{ display: "flex" }}>
                  {socialMediaLinks.map((link, index) => (
                    <a
                      key={index}
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Avatar
                        shape="circle"
                        size={32}
                        icon={
                          <Icon
                            icon={link.icon}
                            style={{ fontSize: "1rem", color: "#003087" }}
                          />
                        }
                        style={{
                          marginLeft: 10,
                          backgroundColor: "transparent",
                          border: "2px solid #DDE0E8",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      />
                    </a>
                  ))}
                </div>
              </div>
              <div style={{ textAlign: "center", marginTop: 20 }}>
                <Typography.Text className="textSmall">
                  © 2023 Copyright owned by one or more of the KPMG
                  International entities. KPMG International entities provide no
                  services to clients. All rights reserved.
                </Typography.Text>
              </div>
            </Col>
            <Col lg={2}></Col>
          </Row>
        </Footer>
      </Fade>
    </div>
  );
};
